import { render, staticRenderFns } from "./UploadCompanyLogo.vue?vue&type=template&id=78ff3d19&"
import script from "./UploadCompanyLogo.vue?vue&type=script&lang=js&"
export * from "./UploadCompanyLogo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports